import { moduleProviderFactory } from 'core/providers';
import { ProductTagEdit, ProductTagList } from 'application/product-tag/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.product-tag',
                pattern: '/product-tag',
                children: [
                    {
                        name: 'master.app.main.product-tag.list',
                        pattern: '',
                        tabTitle: 'PRODUCT_TAG.LIST.TITLE_SECONDARY',
                        component: ProductTagList,
                        data: {
                            title: 'PRODUCT_TAG.LIST.TITLE_SECONDARY'
                        }
                    },
                   {
                        name: 'master.app.main.product-tag.create',
                        pattern: '/create',
                        tabTitle: 'Create Product Tag',
                        component: ProductTagEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'PRODUCT_TAG.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.product-tag.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Product Tag',
                        component: ProductTagEdit,
                        authorization: 'portalSection.update',
                        data: {
                            title: 'PRODUCT_TAG.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.PRODUCT_TAG_SUB',
                        route: 'master.app.main.product-tag.list',
                        order: 10,
                    }                    
                ]
            }
        ]
    });
})();
